import useWidget from './useWidget.js';
const useWidgetQuery = () => {
    return useWidget().query;
};
export default useWidgetQuery;
